import { cn } from "@/utils/utils";
import React from "react";

type Props = {
  className?: string;
  children: React.ReactNode;
};

export const IconBox = ({ className, children }: Props) => {
  return (
    <div
      className={cn(
        "flex grow-0 items-center justify-center rounded bg-gradient-to-tr from-white/0 to-white/[12%] p-2",
        className,
      )}
    >
      {children}
    </div>
  );
};
